import { useState } from 'react';
import { Button } from 'react-bootstrap';
import {
    WorkloadTable,
    Pagination,
} from './components';

const MyWorkload = () => {
    // State for modals
    const [showEditModal, setShowEditModal] = useState(false);
    const [showMoveOrCopyModal, setShowMoveOrCopyModal] = useState(false);
    const [showLogTimeModal, setShowLogTimeModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [showQuickSubtasksModal, setShowQuickSubtasksModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEstimateTimeModal, setShowEstimateTimeModal] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);

    // State for pagination
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    
    // State for expanded rows
    const [expandedRows, setExpandedRows] = useState(new Set());
    const handleToggleRow = (index) => {
        setExpandedRows(prev => {
            const next = new Set(prev);
            if (next.has(index)) {
                next.delete(index);
            } else {
                next.add(index);
            }
            return next;
        });
    };

    // Modal handlers
    const handleShow = () => setShowEditModal(true);
    const handleMoveOrCopyShow = () => setShowMoveOrCopyModal(true);
    const handleLogTimeShow = () => setShowLogTimeModal(true);
    const handleHistoryShow = () => setShowHistoryModal(true);
    const handleQuickSubtasksShow = () => setShowQuickSubtasksModal(true);
    const handleDeleteShow = () => setShowDeleteModal(true);
    const handleEstimateTimeShow = () => setShowEstimateTimeModal(true);
    const handleContactShow = () => setShowContactModal(true);

    // Modal close handlers
    const handleClose = () => setShowEditModal(false);
    const handleMoveOrCopyClose = () => setShowMoveOrCopyModal(false);
    const handleLogTimeClose = () => setShowLogTimeModal(false);
    const handleHistoryClose = () => setShowHistoryModal(false);
    const handleQuickSubtasksClose = () => setShowQuickSubtasksModal(false);
    const handleDeleteClose = () => setShowDeleteModal(false);
    const handleEstimateTimeClose = () => setShowEstimateTimeModal(false);
    const handleContactClose = () => setShowContactModal(false);
    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Workload
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button variant='primary'
                                className='btn-sm text-nowrap'
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add Task
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='c-card-body-1 p-0'>
                    <WorkloadTable
                        onEdit={handleShow}
                        onMoveOrCopy={handleMoveOrCopyShow}
                        onLogTime={handleLogTimeShow}
                        onViewHistory={handleHistoryShow}
                        onAddSubtasks={handleQuickSubtasksShow}
                        onView={() => {}} // TODO: Implement view handler
                        onDuplicate={() => {}} // TODO: Implement duplicate handler
                        onDelete={handleDeleteShow}
                        onEstimateTime={handleEstimateTimeShow}
                        onContactClick={handleContactShow}
                        expandedRows={expandedRows}
                        onToggleRow={handleToggleRow}
                    />
                </div>
                <div className='c-card-footer-1'>
                    <Pagination
                        pageSize={pageSize}
                        onPageSizeChange={setPageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                    />
                </div>
            </div>
        </>
    );
};export default MyWorkload;